import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import router from './routes/router';
import moment from 'moment';
import * as Sentry from "@sentry/vue";

Vue.prototype.moment = moment
Vue.use(DashboardPlugin);

Sentry.init({
  Vue,
  dsn: "https://7142f9bebf8dc936eafdb009d9579e58@o4509405690331136.ingest.de.sentry.io/4509474290729040",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["https://bportal.e-consulting.org"],
  sendDefaultPii: true,
});

Vue.config.errorHandler = function (err, vm, info) {
    Sentry.captureException(err);
};


new Vue({
    el: '#app',
    data: {
        user: null,
        app_name: process.env.APP_NAME,
        locale: process.env.MIX_LOCALE,
        locales: process.env.MIX_LOCALES.split(','),
        base_path: process.env.MIX_BASE_PATH,
        back: {name: 'dashboard'},
        default_back: {name: 'dashboard'},
    },
    render: h => h(App),
    router
});
